export const ValidarEntrada = (entrada) => {

  const today = new Date();
  const vencimiento = entrada.vencimiento_fecha && entrada.vencimiento_fecha != '0000-00-00'?  new Date(entrada.vencimiento_fecha) : new Date() ;
  const habilitacion = entrada.habilitacion_fecha ? new Date(entrada.habilitacion_fecha) : new Date();

  if (today >= habilitacion && today <= vencimiento && entrada.status == 'ACTIVO') {
    return true;
  }

  return false;
};
